
import { PENSION_CALCULATOR_CTA_LINKS } from '@/utils/pension-calculator-constants';

import FButton from '@/components/atoms/buttons/h-button';
import FIcon from '@/components/atoms/icons/h-icon';
import GoogleReview from '~cl/atoms/review-community-rating/google-rating';
import breakpointHelper from '@/mixins/breakpoint-helper';

export default {
  name: 'PensionOfferCta',

  components: {
    FButton,
    FIcon,
    GoogleReview,
  },

  mixins: [breakpointHelper],

  props: {
    showCtaExperiment: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      buttonHref: this.$t(
        PENSION_CALCULATOR_CTA_LINKS['pensionfriend-appointment'],
      ),
      items: [this.$t('items.0'), this.$t('items.1'), this.$t('items.2')],
    };
  },

  computed: {
    imageStyle() {
      return {
        backgroundImage: `url(${
          this.isMobile
            ? require('@/assets/images/pension-calculator/request-offer-mobile@2x.png')
            : require('@/assets/images/pension-calculator/request-offer@2x.png')
        })`,
      };
    },
  },

  methods: {
    async handleButtonClick() {
      await this.$eventTrackClick('Website Pension Calculator CTA Button', {
        Label: 'Request your offer',
      });

      setTimeout(() => {
        window.location.href = this.buttonHref;
      }, 1000);
    },
  },
};
